import React from 'react';
import './popover.scss';

export default props => {

    return (
        <div className="popover__component" >
            <div className="popover__wrapper">
                {/* <h2 class="popover__title">Hover:me</h2> */}
                <img className="icon-info" src={props.icon} alt="info" onClick={props.click}/>
                <div className="popover__content" hidden={props.messageHidden !== null && props.messageHidden !== undefined}>
                    <p className="popover__message">{props.message}</p>
                </div>
            </div>
        </div>
    );
}